

    <form [formGroup]="periodiekeUitkeringen">
        <div class="row">
            <ng-container formArrayName="box3PeriodiekeUitkeringen">
                <ng-container *ngFor="let item of box3PeriodiekeUitkeringen.controls; let i = index; "
                              [formGroupName]="i">
                    <div>
                        <snelstart-ui-text-form-control formControlName="omschrijving"
                                                        id="omschrijving"
                                                        [label]="i === 0 ? 'Omschrijving recht periodieke uitkering' : ''"
                                                        class="custom-input-250"
                                                        (change)="saveForm()"
                        >
                        </snelstart-ui-text-form-control>
                        <snelstart-ui-number-form-control formControlName="bedrag"
                                                          id="bedrag"
                                                          [label]="i === 0 ? 'Waarde 1-1' : ''"
                                                          class="custom-input-150"
                                                          [decimals]="0"
                                                          [minValue]="0"
                                                          align="right"
                                                          prefix="€"
                                                          (change)="saveForm()"

                        >
                        </snelstart-ui-number-form-control>
                        <snelstart-ui-button id="buttonDeleteKosten"
                                                    type="secondary"
                                                    size="medium"
                                                    iconType="light"
                                                    (click)="verwijderRijPeriodiekeUitkeringen(i)"
                                                    [class]="i === 0 ? 'firstrowbutton' : ''"
                        >
                        </snelstart-ui-button>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </form>

    <div *ngIf="box3PeriodiekeUitkeringen.length === 0">
        <snelstart-ui-button class="snelstart-ui-button pb-3" type="link" icon="plus"
                             (click)="addRijPeriodiekeUitkeringen()">Recht op periodieke uitkering invullen
        </snelstart-ui-button>
    </div>
    <div *ngIf="box3PeriodiekeUitkeringen.length > 0">
        <snelstart-ui-button class="snelstart-ui-button pb-3" type="link" icon="plus"
                             (click)="addRijPeriodiekeUitkeringen()">Recht op periodieke uitkering toevoegen
        </snelstart-ui-button>
    </div>




